<template>
  <div class="editResponsibility">
    <div class="filters">
      <el-form :inline="true">
        <!-- 权限说明的折叠板 -->
        <el-collapse v-model="collapse" prop="collapse" class="collapse"> 
          <el-collapse-item :title="$t('lang.lab_privilegeDescription')">
            <div><span class="quote">{{$t('lang.lab_code')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionEncoding')}}</div>
            <div><span class="quote">{{$t('lang.lab_codeName')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionDisplayName')}}</div>
            <div><span class="quote">{{$t('lang.lab_cellRights')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_permissUsedCommunityLocated')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_onlyAuthorizedUsePermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_onlyDevelopersPermission')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_permissionOrdinaryAdministrators')}}{{$t('lang.lab_period')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_contain')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span></div>
            <div><span class="quote">{{$t('lang.lab_category')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionsAre')}}<span class="classical">{{$t('lang.lab_radioSelectionType')}}</span>{{$t('lang.lab_suchAsGender')}}{{$t('lang.lab_asWelllAs')}}
                 <span class="classical">{{$t('lang.lab_multipleSelectionType')}}</span>{{$t('lang.lab_suchAsIndividualPermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_status')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_whetherAvailable')}}</div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_returnResponsibilityList')}}</el-button>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_w6" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_responsibilityCode')" prop="code">
          <el-input v-model="ruleForm.code" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_responsibilityCode')" class="input-width" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_responsibilityName')" prop="name">
          <el-input v-model="ruleForm.name" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_responsibilityName')" class="input-width" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_responsibilityLevel')" prop="grade">
          <el-select v-model="ruleForm.grade" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_responsibilityLevel')">
            <el-option
              v-for="(item, index) in gradeList"
              :key="index"
              :value="item.id"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_opeateRange')" prop="opeateRange">
          <el-select v-model="ruleForm.opeateRange" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_opeateRange')">
            <el-option
              v-for="(item, index) in opeateRangeList"
              :key="index"
              :value="item.id"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_flag')" prop="flag">
          <el-select v-model="ruleForm.flag" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_flag')">
            <el-option
              v-for="(item, index) in flagList"
              :key="index"
              :value="item.id"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_authorityType')" prop="authorityType">
          <el-select v-model="ruleForm.authorityType" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_authorityType')">
            <el-option
              v-for="(item, index) in authorityTypeList"
              :key="index"
              :value="item.id"
              :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form :rules="optionRules" :model="formData" ref="formDom">
          <el-table :data="formData.tableData" border class="table-position">
            <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_responsibilityOption')" width="50px" ></el-table-column>
            <el-table-column prop="optionName" :label="$t('lang.lab_responsibilityOptionName')" align="center">
              <template slot-scope="scope">
                  <el-form-item :prop="'tableData.' + scope.$index + '.optionName'" :rules='optionRules.optionName'>
                    <el-input v-model="scope.row.optionName" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_responsibilityOptionName')" maxlength="50"></el-input>
                  </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="value" :label="$t('lang.lab_responsibilityOptionValue')" align="center">
                <template slot-scope="scope">
                  <el-form-item :prop="'tableData.' + scope.$index + '.value'" :rules='optionRules.value'>
                    <el-input @input="keyOV" v-model="scope.row.value" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_responsibilityOptionValue')" maxlength="200"></el-input>
                  </el-form-item>
                </template>
            </el-table-column>
            <el-table-column  align="center">
              <template slot="header" slot-scope="scope">
                <el-button @click="addOption(scope.row)">{{$t('lang.lab_responsibilityOptionOperation')}}</el-button>
              </template>
              <template slot-scope="scope">
                <el-button class="orange" @click="deleteOne(scope.$index)">{{$t('lang.btn_delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm','formDom')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:editResponsibility
 *@Description:职责管理-新建/编辑页面
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-01
 */

export default {
  data() {
    return {
      rules: {
        code: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_responsibilityCode'), trigger: 'blur' }],
        name: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_responsibilityName'), trigger: 'blur' }],
      },
      optionRules: {
        optionName: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_responsibilityOptionName'), trigger: 'blur' }],
        value: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_responsibilityOptionValue'), trigger: 'blur' }],
      },
      disabledArr: {
        ruleFormDisabled: true,
        formDataDisabled: true,
      }, // 保存的集合
      disabledArrSave: {
        ruleFormDisabled: true,
        formDataDisabled: true,
      }, // 保存的集合Save
      disabledSaveData: '', // 保存数组存储json字符串
      isDisabled: true, // 保存的可点击
      isFlag: false, // 编辑:true 新增：false
      ruleForm: {
        code: '',
        name: '',
        grade: 0,
        opeateRange: 1,
        flag: 1,
        authorityType: 0,
      },
      formData: {
        tableData: [{
          name: '',
          optionName: '',
          value: '',
        }]
      }, // 职责选项列表
      optionsValue: '',
      collapse: [], // 权限说明的折叠
      gradeList: this.$i18n.t('lang.EditResponsibility_gradeList'), // 等级
      opeateRangeList: this.$i18n.t('lang.EditResponsibility_opeateRangeList'), // 操作权限范围
      flagList: this.$i18n.t('lang.EditResponsibility_flagList'), // 是否启用
      authorityTypeList: this.$i18n.t('lang.EditResponsibility_authorityTypeList'), // 类别
    }
  },
  // #8449 add
  destroyed() {
    window.localStorage.setItem('responsibilityManagementForm', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('responsibilityManagementSaveData', this.saveData)
    window.localStorage.setItem('responsibilityManagementTableData', JSON.stringify(this.formData.tableData))
    window.localStorage.setItem('responsibilityManagementSaveOption', this.saveOption)  
  },
  created() {
    // 这是用来保存disabled们初始数据
    this.disabledSaveData = JSON.stringify(this.disabledArrSave)
    // 判断编辑与新增
    this.isFlag = this.$route.query.flag
    this.id = this.$route.query.id
    // #8449 add
    if (window.localStorage.getItem('responsibilityManagementForm')) {
      this.ruleForm = JSON.parse(window.localStorage.getItem('responsibilityManagementForm'))
      if (window.localStorage.getItem('responsibilityManagementSaveData')) {
        this.saveData = window.localStorage.getItem('responsibilityManagementSaveData')
      }
      if (window.localStorage.getItem('responsibilityManagementTableData')) {
        this.formData.tableData = JSON.parse(window.localStorage.getItem('responsibilityManagementTableData'))
      }
      if (window.localStorage.getItem('responsibilityManagementSaveOption')) {
        this.saveOption = window.localStorage.getItem('responsibilityManagementSaveOption')
      }
    } else {
      if (this.isFlag && this.isFlag !== 'false') {
        this.getEditData()
      }
    }
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.disabledArr.ruleFormDisabled = true
        } else {
          // 变了
          this.disabledArr.ruleFormDisabled = false
        }
        console.log('watch ruleForm', this.disabledArr.ruleFormDisabled)
      },
      deep: true,
      immediate: true
    },
    'formData.tableData': {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveOption) {
          // 没变
          this.disabledArr.formDataDisabled = true
        } else {
          // 变了
          this.disabledArr.formDataDisabled = false
        }
        console.log('formData.tableData', this.disabledArr.formDataDisabled)
      },
      deep: true,
      immediate: true
    },
    disabledArr: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.disabledSaveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
        console.log('this.isDisabled', this.isDisabled)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 职责管理编辑页面根据id获取数据
    getEditData() {
      let loading = this.$loading()
      this.$get(`/getAuthorityInfoById/` + this.id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.ruleForm = res.authorityManager
            this.formData.tableData = res.authorityOption
            // 添加元素'isDelete'
            for (var x = 0; x < this.formData.tableData.length; x++) {
              this.formData.tableData[x].isDelete = 0
            }
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
            this.saveOption = JSON.stringify(this.formData.tableData)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 返回
    back() {
      this.$router.push({ name: 'responsibilityManagementList' })
    },
    // 保存
    save(formName, formName1) {
      if (this.formData.tableData.length === 0) {
        this.$message.warning(this.$i18n.t('lang.lab_responsibilityOptionList'))
        return        
      }
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          let params = { }
          if (this.isFlag) {
            params.Id = this.ruleForm.id
          }
          params.Code = this.ruleForm.code
          params.Name = this.ruleForm.name
          params.Grade = this.ruleForm.grade
          params.OpeateRange = this.ruleForm.opeateRange
          params.AuthorityType = this.ruleForm.authorityType
          params.Flag = this.ruleForm.flag
          params.options = this.formData.tableData

          this.$refs[formName].validate((valid) => {
            if (valid) {
              let loading = this.$loading()              
              this.$postJson(`/AOEAuthority`, JSON.stringify(params)).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({ name: 'responsibilityManagementList' })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              return false
            }
          })
        } else {
          this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
              return false
            }
          })
          return false
        }
      })
    },
    // 清空
    resetForm(formName) {
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.code = ''
      this.ruleForm.name = ''
      this.ruleForm.grade = 0
      this.ruleForm.opeateRange = 1
      this.ruleForm.flag = 1
      this.ruleForm.authorityType = 0
      this.$refs.formDom.clearValidate()
      this.formData.tableData = [{
          name: '',
          optionName: '',
          value: '',
        }]
    },
    // 职责选项值只能输入数字
    keyOV() {
      for (var x = 0; x < this.formData.tableData.length; x++) {
        // 仅保留数字
        var temp = this.formData.tableData[x].value
        temp = String(temp)
        this.formData.tableData[x].value = temp.replace(/[^\d]/g, '')
      // 首位是0的话去掉
        if (this.formData.tableData[x].value.indexOf('.') < 0 && this.formData.tableData[x].value != '') {
          this.formData.tableData[x].value = parseFloat(this.formData.tableData[x].value)
        }
      }
    },
    addOption(data) {
      // 新填选项行显示
      var newValue = {
        name: '',
        optionName: '',
        value: '',
      }
      // 添加新行数
      this.formData.tableData.push(newValue)
    },
    // 删除选项值
    deleteOne(index) {
      this.$confirm(
        this.$i18n.t('lang.lab_responsibilityOptionDeleteWarning'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.formData.tableData.splice(index, 1)
          if (index === 0 && this.formData.tableData.length < 1) {
            this.formData.tableData = [{
              name: '',
              optionName: '',
              value: '',
            }]
          }
          this.reCheck('formDom')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    reCheck(formName) {
      this.$refs.formDom.clearValidate()
      this.$refs[formName].validate() 
      // if（Error: please transfer a valid prop path to form item!）使用如下方法,等待dom队列完成再调用
      // this.$nextTick(this.$refs[formName].validate)
    },
    // ID序号功能
    indexMethod(index) {
      return index + 1
    },
  } 
}
</script>

<style lang="scss">
.editResponsibility {
  .el-table__header {
    width: 100% !important;
  }
  .el-table__empty-block {
    width: 100% !important;
  }
  .el-table__body {
    width: 100% !important;
  }
  .collapse {
    .el-collapse-item__header {
      font-size: 16px;
      padding-left: 0%;
      margin-left: 0px;
      border-bottom: 0px;
    }
    .el-collapse {
      border-top: 0px;
    }
    .el-collapse-item__content {
      font-size: 16px;
    }
    .el-collapse-item__wrap {
      will-change: height;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #ebeef5;
    }
  }
  .el-collapse {
    border-top: 0px;
  }
  .quote {
    color: steelblue;
  }
  .classical {
    color: #419641;
  }
  .input-width{
    width: 30%;
  }
  .table-position{
    margin-top: 40px;
    margin-left: 40px;
    margin-bottom: 40px;
    width: 60%
  }
  .small-form{
    .el-form-item {
      margin-bottom: 0px;
    }
  }
}
</style>